import { render, staticRenderFns } from "./plogupload.vue?vue&type=template&id=77f65a2c&scoped=true&"
import script from "./plogupload.vue?vue&type=script&lang=js&"
export * from "./plogupload.vue?vue&type=script&lang=js&"
import style0 from "./plogupload.vue?vue&type=style&index=0&id=77f65a2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f65a2c",
  null
  
)

export default component.exports